export const selectNotifsInfo = state => state.notifications
export const selectNotifs = state => state.notifications.value
export const selectIsLoadingForFirstTime = state => state.notifications.isLoadingForFirstTime
